import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { isNotNull } from '@rd/utils/isNotNull';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  getPromocodeBanner,
  getPromocodeBanners,
} from '../store/promocode-banner.selectors';
import { PromocodeBanner } from '../types';

@Injectable({
  providedIn: 'root',
})
export class PromocodeBannerFacade {
  constructor(private store: Store) {}

  promocodeBanners$: Observable<PromocodeBanner[]> =
    this.store.select(getPromocodeBanners);

  promocodeBanner$: Observable<PromocodeBanner> = this.store
    .select(getPromocodeBanner)
    .pipe(filter(isNotNull));
}
